import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SpellingSuggestion } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { ComponentService } from 'src/app/service/component.service';

@Component({
  selector: 'app-spelling-suggestion',
  templateUrl: './spelling-suggestion.component.html',
  styleUrls: ['./spelling-suggestion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SpellingSuggestionComponent implements OnInit, OnDestroy {
  @Input() didYouMean: SpellingSuggestion;
  searchBoxQuerySubscription$: Subscription;
  searchBoxSuggestionSubscription$: Subscription;
  searchBoxQuery: string;
  searchBoxSuggestions: string[] = [];

  constructor(
    private componentService: ComponentService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.searchBoxQuerySubscription$ = this.route.params.subscribe((routeParams) => {
      this.searchBoxQuery = routeParams.query;
      this.cdr.detectChanges();
    });

    this.searchBoxSuggestionSubscription$ = this.componentService.searchBoxSuggestions$.subscribe((keywords) => {
      this.searchBoxSuggestions = keywords;
      this.cdr.detectChanges();
    });
  }

  showSearchInstead(searchBoxSuggestions: string[], query: string): boolean {
    return searchBoxSuggestions.length === 0 || !query
      ? false
      : !searchBoxSuggestions.includes(query) && !query.includes('Groupset');
  }

  ngOnDestroy() {
    if (this.searchBoxQuerySubscription$) {
      this.searchBoxQuerySubscription$.unsubscribe();
    }
    if (this.searchBoxSuggestionSubscription$) {
      this.searchBoxSuggestionSubscription$.unsubscribe();
    }
  }
}
